import {Col, Container, OverlayTrigger, Row, Tooltip} from 'react-bootstrap';
import DataTable from '../../../common/DataTable';
import {useEffect, useRef, useState} from 'react';
import {
  getSharedByMeList,
  getSharedWithMeList,
} from '../../../services/SharedRecordsApi';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/Store';
import {ShareByMeHeader, ShareWithMeHeader} from '../actions/Constant';
import SearchInput from '../../../common/InlineSearch';
import {dateTimeFormatted} from '../../../utils/dateUtils';
import {SHARE_RECORDS_STATUS} from '../../../common/Constant';
import Loader from '../../../common/Loader';

interface ShareRecordsProps {
  onRowSelect: (selectedRowData: any, tabStatus: string) => void;
  headerActiveTab: string;
  actionsAccess: any;
}

const SharedByMeList: React.FC<ShareRecordsProps> = ({onRowSelect, headerActiveTab, actionsAccess}) => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const hasEdit = actionsAccess.includes("Edit");
  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const searchInputRef = useRef<any>(null);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const searchTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [searchQuerylength, setSearchQuerylength] = useState<string>('');
  const latestRequestRef = useRef(0);
  const [loading, setLoading] = useState<boolean>(false);
  const isFirstRender = useRef(true);

  const getStatusColor = (status: string) => {
    switch (status) {
      case SHARE_RECORDS_STATUS.ACTIVE:
        return 'text-success'; 
      case SHARE_RECORDS_STATUS.REVOKED:
        return 'text-danger'; 
      case SHARE_RECORDS_STATUS.EXPIRED:
        return 'text-secondary'; 
      default:
        return 'text-secondary'; 
    }
  };

  const fetchListData = async (
    loggedInUserid: number | null,
    query: string = "",
  ) => {
    const requestId = ++latestRequestRef.current;
    try {
      setLoading(true);
      const shareData = await getSharedByMeList(loggedInUserid, query);
      if (shareData) {
        if (requestId !== latestRequestRef.current) return;
        const formattedData = shareData.map((item: any) => ({
          ...item,
          subjectFullName: (
            <OverlayTrigger
              placement="auto"
              delay={{ show: 200, hide: 100 }}
              overlay={
                <Tooltip id={`tooltip-sharedBy-${item.id}`}>
                  {item.subjectFullName}
                  {/* <br />
                  {item.caseName} */}
                </Tooltip>
              }
            >
              <span className="d-inline-block" style={{ cursor: "pointer" }}>
                <span className="theme-color d-block">{item.subjectFullName}</span>{" "}
                {/* <span className="bb">{item.caseName}</span> */}
              </span>
            </OverlayTrigger>
          ),
          expiryDateNew: item.expiryDate
            ? dateTimeFormatted(item.expiryDate)
            : "",
          shareStatus: (
            <span className={getStatusColor(item.shareStatus)}>
              {item.shareStatus}
            </span>
          ),
          status: item.shareStatus,
          actions: hasEdit ? item.actions : "",
          sharedBy_On: (
            <OverlayTrigger
              placement="auto"
              delay={{ show: 200, hide: 100 }}
              overlay={
                <Tooltip id={`tooltip-sharedBy-${item.id}`}>
                  {item.sharedBy}
                  <br />
                  {dateTimeFormatted(item.sharedOn)}
                </Tooltip>
              }
            >
              <span className="d-inline-block" style={{ cursor: "pointer" }}>
                <span className="d-block">{item.sharedBy}</span>
                <span className="bb">{dateTimeFormatted(item.sharedOn)}</span>
              </span>
            </OverlayTrigger>
          ),
        }));

        setData(formattedData);
        setFilteredData(formattedData);
      }
    } catch (error) {
      console.error("failed to fetch data:", error);
    } finally {
      if (requestId === latestRequestRef.current) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (headerActiveTab !== "Shared By Me" || !loggedInUserid) return;
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      fetchListData(loggedInUserid, searchQuery);
    }, 300);

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchQuery, headerActiveTab]);

  const handleSearchQueryChange = (query: string) => {
    setSearchQuery(query);
  };

  const handleSearchQueryChangeForlength = (query: string) => {
    setSearchQuerylength(query?.trim());
  };

  const handleReset = () => {
    searchInputRef.current?.clear();
    setSearchQuery('');
    setSearchQuerylength('');
  };

  const handleRowAction = (row: any, action: string) => {
    onRowSelect(row, 'SharedByMe');
  };

  return (
    <>
    <Loader isLoading={loading} />
    <Container fluid className='pb-5'>
      <Row className='mt-3 align-items-center px-2 py-1 '>
        <Col className='d-flex justify-content-between align-items-center border-bottom pb-1 px-0 cancelappointment'>
          <h3 className='mr-2 me-auto'>List</h3>
          <div
            className='d-flex  py-2 search_closer align-items-center position-absolute justify-content-end'
            style={{marginTop: '-15px', right: '57px', width: '30%'}}
          >
            <div style={{width: '85%'}} className='gridsearch'>
              <SearchInput
                ref={searchInputRef}
                data={data}
                searchKeys={[]}
                onSearchResult={setFilteredData}
                placeholder='Search'
                onSearchQueryChange={handleSearchQueryChange}
                onInputChange={handleSearchQueryChangeForlength}
              />
            </div>
            <button
              onClick={handleReset}
              className='reset_btn'
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                marginTop: '3px',
              }}
            >
              <span className='material-icons reset_ic0'>restart_alt</span>
            </button>
          </div>
        </Col>
      </Row>
      <Row className='px-0'>
        <DataTable
          headers={ShareByMeHeader}
          rows={data}
          onAction={handleRowAction}
        />
      </Row>
    </Container>
    </>
  );
};
export default SharedByMeList;
